import { useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Star } from "lucide-react";
import { useProjects } from "../../lib/useProjects";
import { api, img, errMsg } from "../../lib/api";
import { ProjectForm } from "./ProjectForm";

export const ProjectsManager = ({ kind }) => {
  const { items, loading, reload } = useProjects(kind);
  const [editing, setEditing] = useState(null);
  const label = kind === "wedding" ? "matrimonio" : "creazione";

  const remove = async (p) => {
    if (!window.confirm(`Eliminare "${p.title}"?`)) return;
    try {
      await api.delete(`/projects/${p.id}`);
      toast.success("Eliminato");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid={`admin-projects-${kind}`}>
      <div className="flex items-center justify-between gap-4">
        <p className="text-ash text-sm">{items.length} elementi</p>
        <button data-testid={`admin-add-${kind}`} onClick={() => setEditing({ kind })} className="inline-flex items-center gap-2 rounded-full bg-cypress text-cream px-5 py-2.5 text-sm hover:bg-terra transition-colors"><Plus className="w-4 h-4" /> Nuovo {label}</button>
      </div>
      {loading ? <p className="mt-8 text-ash">Caricamento…</p> : (
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((p) => (
            <div key={p.id} data-testid={`admin-item-${p.id}`} className="bg-white border border-stone">
              <div className="relative aspect-[4/3] bg-sand">
                {p.images?.[0] && <img src={img(p.images[0])} alt={p.title} className="w-full h-full object-cover" />}
                {p.featured && <span className="absolute top-3 left-3 inline-flex items-center gap-1 bg-cream text-terra text-xs px-2 py-1 rounded-full"><Star className="w-3 h-3" /> In evidenza</span>}
              </div>
              <div className="p-4">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-terra">{p.category || "—"}</p>
                <p className="mt-1 font-serif text-xl text-ink">{p.title}</p>
                <p className="text-xs text-ash">{p.images?.length || 0} foto</p>
                <div className="mt-4 flex gap-2">
                  <button data-testid={`admin-edit-${p.id}`} onClick={() => setEditing(p)} className="inline-flex items-center gap-1.5 rounded-full border border-stone px-3 py-1.5 text-sm hover:border-cypress"><Pencil className="w-3.5 h-3.5" /> Modifica</button>
                  <button data-testid={`admin-delete-${p.id}`} onClick={() => remove(p)} className="inline-flex items-center gap-1.5 rounded-full border border-stone px-3 py-1.5 text-sm text-red-700 hover:border-red-700"><Trash2 className="w-3.5 h-3.5" /> Elimina</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <ProjectForm project={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); reload(); }} />
    </div>
  );
};
